import { Injectable, Injector } from '@angular/core';
import { OrgaoAudesp } from '../../entidade/comum/orgao-audesp.model';
import { BaseResourceService } from '../../models/services/base-resource.service';

@Injectable({
  providedIn: 'root'
})
export class OrgaoAudespService extends BaseResourceService<OrgaoAudesp> {

  constructor(
    protected injector: Injector
  ) {
    super(`orgaos-audesp`, injector);
  }

}
